import type { ConsentDefinitionDto } from '../types/consent';
import type { ConsentTriValue } from '../components/ConsentTriYesNo/ConsentTriYesNo';

export function getServerTriState(c: ConsentDefinitionDto): 'Yes' | 'No' | null {
  const r = (c.currentConsentResponse || '').trim();
  if (r !== 'Yes' && r !== 'No') return null;
  const responded = (c.respondedVersion || '').trim();
  const cv = (c.consentVersion || '').trim();
  if (responded && cv && responded !== cv) return null;
  return r as 'Yes' | 'No';
}

export function getEffectiveConsentValue(
  c: ConsentDefinitionDto,
  draft: Record<number, ConsentTriValue>
): ConsentTriValue {
  if (Object.prototype.hasOwnProperty.call(draft, c.definitionItemId)) {
    return draft[c.definitionItemId];
  }
  return getServerTriState(c);
}

export function areAllConsentsAnswered(
  definitions: ConsentDefinitionDto[],
  draft: Record<number, ConsentTriValue>
): boolean {
  return definitions.every((c) => {
    const v = getEffectiveConsentValue(c, draft);
    return v === 'Yes' || v === 'No';
  });
}
